// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {Modal} from '../../../../shared/ui/modal';
import {Button} from '../../../../shared/button';
import styles from './styles.module.less';

interface i_sa_login_popup_props {
    is_open: boolean;
    on_close: ()=>void;
    on_signin: ()=>void;
    is_client: boolean;
}

export const Settlement_login_popup = (props: i_sa_login_popup_props)=>{
    const {is_open, on_close, on_signin, is_client} = props;
    if (!is_client)
        return null;
    return <Modal is_open={is_open} on_close={on_close}
      paddingless no_logo width={468}>
      <div className={cn(styles.settlement_login_popup)}>
        <div className={cn(styles.content_section)}>
          <div className={cn(styles.title_and_content)}>
            <div className={cn(styles.title)}>
              Class action settlement in CA (Dist. - TA) 62567-02-22
            </div>
            <div className={cn(styles.content)}>
              Dear Hola user, you may be entitled to a benefit under the
              class action settlement. Please sign in to check your
              eligibility and receive your benefit.
            </div>
            <div className={styles.button_wrapper}>
              <Button caption={'Sign in'}
                size="md" round on_click={on_signin}
                cls={styles.button}/>
            </div>
          </div>
        </div>
      </div>
    </Modal>;
};
